<template>
  <div class="loader">
    <span :style="`background:${color}`"></span>
    <span :style="`background:${color}`"></span>
    <span :style="`background:${color}`"></span>
    <span :style="`background:${color}`"></span>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#fff"
    }
  }
};
</script>
<style scoped>
.loader {
  display: block;
  width: fit-content;
  margin: auto;
}
.loader span {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  transform: scale(0.5);
  animation: scale-dot 1.2s ease-out infinite;
}
.loader span:nth-of-type(2) {
  animation-delay: 0.2s;
}

@keyframes scale-dot {
  0% {
    transform: scale(0.5);
  }
  25% {
    transform: scale(1);
  }
  75% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(0.5);
  }
}
</style>
